import * as React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import Modal from '@mui/material/Modal'
import { Box, Typography } from '@mui/material'
import { CustomButton } from 'components/CustomButton'

const ModalDelete = ({ open, handleClose }) => {
    const { t } = useTranslation()
    return (
        <Modal
            aria-labelledby="spring-modal-title"
            aria-describedby="spring-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            sx={{ backdropFilter: 'blur(2px)' }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '90%',
                    maxWidth: 470,
                    bgcolor: '#FFFFFF',
                    p: '30px 25px',
                    borderRadius: '12px',
                    boxShadow: '0px 8px 24px rgba(0,0,0,0.12)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '12px',
                }}
            >
                <Box
                    component="i"
                    className="icon-alerta_modal"
                    sx={{ fontSize: '72px', color: '#F8BB86' }}
                />
                <Typography
                    fontWeight={700}
                    color="#21409A"
                    textAlign="center"
                    fontSize="15px"
                    letterSpacing="0.5px"
                >
                    {t('CONTA ENCERRADA')}
                </Typography>
                <Box display="flex" flexDirection="column" alignItems="center" gap="6px" mt="4px">
                    <Typography color="#5D5D5D" fontSize="14px" textAlign="center" lineHeight={1.6}>
                        {t('Ficamos tristes com a exclusão da sua conta.')}
                    </Typography>
                    <Typography color="#5D5D5D" fontSize="14px" textAlign="center" lineHeight={1.6}>
                        {t('Seus dados foram excluídos completamente da nossa base.')}
                    </Typography>
                    <Typography color="#5D5D5D" fontSize="14px" textAlign="center" lineHeight={1.6}>
                        Mas lembre-se, você pode voltar ao Programa a hora que quiser,
                        basta se cadastrar novamente.
                    </Typography>
                    <Typography color="#5D5D5D" fontSize="14px" textAlign="center">
                        {t('Até logo.')}
                    </Typography>
                </Box>
                <Box mt="8px">
                    <CustomButton
                        size="sm"
                        variant="contained"
                        defaultColor="#F05B4F"
                        onClick={handleClose}
                        style={{ minWidth: '120px' }}
                    >
                        {t('Fechar')}
                    </CustomButton>
                </Box>
            </Box>
        </Modal>
    )
}

ModalDelete.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func,
}

export default ModalDelete
